import "../css/CRMSummaryBox.css";
import { formatValueUnit } from "../js/utils";

export function CRMSummaryBox({ title, data, sales = false }) {
  return (
    <div className="crm-summary-box-content thin-rounded-border">
      <div
        className="crm-summary-box-subsection crm-summary-box-border"
        style={{ gap: 10 }}
      >
        <div className="section-content-title">{title}</div>
        <div style={{ fontSize: 25, fontWeight: 500 }}>
          {sales
            ? formatValueUnit(data.totalVentas, "") +
              " / " +
              formatValueUnit(data.totalValorVenta, "€")
            : formatValueUnit(data.total, "")}
        </div>
      </div>
      <div style={{ display: "flex", gap: 20 }}>
        <div className="crm-summary-box-subsection">
          <img src="/images/sms.svg" className="section-header-icon" alt="SMS" />
          <span>{formatValueUnit(data.totalSMS, "")}</span>
        </div>
        <div className="crm-summary-box-subsection">
          <img src="/images/whatsapp.svg" className="section-header-icon" alt="WhatsApp" />
          <span>{formatValueUnit(data.totalWhatsapp, "")}</span>
        </div>
        <div className="crm-summary-box-subsection">
          <img src="/images/email.svg" className="section-header-icon" alt="Email" />
          <span>{formatValueUnit(data.totalEmail, "")}</span>
        </div>
        <div className="crm-summary-box-subsection">
          <img src="/images/rcs-blue.svg" className="section-header-icon" alt="RCS" />
          <span>{formatValueUnit(data.totalRCS, "")}</span>
        </div>
      </div>
    </div>
  );
}
